
import type { Instant } from '@shared/tz';
import { cx } from '@client/shared/lib/cx.ts';
import {
  formatViewerTime,
  formatViewerRange,
  formatViewerDate,
} from '@client/shared/lib/viewer-timezone.ts';

function isoOf(instant: Instant): string {
  const date = instant instanceof Date ? instant : new Date(instant);
  return Number.isNaN(date.getTime()) ? '' : date.toISOString();
}

export interface TimeProps {
  at: Instant;
  date?: boolean;
  className?: string;
}

export function Time({ at, date = false, className }: TimeProps) {
  const text = date ? formatViewerDate(at) : formatViewerTime(at);
  return (
    <time dateTime={isoOf(at)} className={cx('tnum', className)}>
      {text}
    </time>
  );
}

export interface TimeRangeProps {
  start: Instant;
  end: Instant;
  className?: string;
}

export function TimeRange({ start, end, className }: TimeRangeProps) {
  return (
    <time dateTime={`${isoOf(start)}/${isoOf(end)}`} className={cx('tnum', className)}>
      {formatViewerRange(start, end)}
    </time>
  );
}
